import React from 'react';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText
} from '@mui/material';

export default function CheckboxField(props:any) {
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);
 
  const formikProps:any = useFormikContext();
  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  function _onChange(e:any) {
    formikProps.setFieldValue(field.name, e.target.checked);
  }

  return (
    <FormControl {...rest}>
      <FormControlLabel
        control={<Checkbox {...field} name={field.name} checked={formikProps.values[field.name]} onChange={_onChange} />}
        label={label}
      />
      {_renderHelperText()}
    </FormControl>
  );
}
